import { FilterDTO } from './filter.dto';

export class AreaSearchByPostCodeDTO {
  constructor(public readonly postCode: string,
              public readonly reportFilter: FilterDTO) {
  }
}
